import { showMsg } from '@/utils/snackbar'

export default {
    mounted(el) {

        let timeout = null

        const handler = (e) => {

            const value = e.target.value

            // فقط حروف انگلیسی، عدد و underline
            const sanitized = value.replace(/[^a-zA-Z0-9_]/g, '')

            if (value !== sanitized) {

                if (!timeout) {

                    showMsg(
                        'فقط حروف انگلیسی، عدد و _ مجاز است',
                        'red'
                    )

                    timeout = setTimeout(() => {
                        timeout = null
                    }, 1500)
                }

                e.target.value = sanitized

                e.target.dispatchEvent(
                    new Event('input', { bubbles: true })
                )
            }
        }

        el.addEventListener('input', handler)

        el.__keySafeHandler = handler
    },

    unmounted(el) {
        if (el.__keySafeHandler) {
            el.removeEventListener('input', el.__keySafeHandler)
            delete el.__keySafeHandler
        }
    }
}
